import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { LanguageService } from "../../_services/language.service";

@Component({
  selector: "app-my-modal",
  templateUrl: "./my-modal.component.html",
  styleUrls: ["./my-modal.component.scss"],
})
export class MyModalComponent implements OnInit {
  // languages: Languages[];
  //languages: any [];
  languages: any = [];
  countries: any = [];
  isLoaded = false;

  selectedLocale: any;
  selectedCountry: any;

  constructor(
    public dialogRef: MatDialogRef<MyModalComponent>,
    private languageService: LanguageService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  getLanguagesAndCountries(): void {
    this.languageService.getLocales().subscribe((data) => {
      if (data) {
        this.languages = data.locales;
        this.countries = data.countries;
        this.isLoaded = true;
      } else {
        console.log("Ni podakov");
      }
    });
  }

  onLanguageSet() {
    if (this.selectedCountry && this.selectedLocale) {
      this.languageService.setLocaleAndCountry(this.selectedLocale, this.selectedCountry);
      this.dialogRef.close();
    }
  }

  ngOnInit() {
    this.getLanguagesAndCountries();
  }
}
